<template>
  <div
    :class="DS_NUMBER_FIELD_CLASSES.Controls"
    data-cy="ds-number-field__controls"
  >
    <span
      :class="[DS_NUMBER_FIELD_CLASSES.ControlButton, DS_NUMBER_FIELD_CLASSES.Decrement]"
      data-cy="ds-number-field__decrement"
    >
      <DSButton
        :variant="DS_BUTTON_VARIANT.Ghost"
        :size="DS_SIZE.Small"
        :type="DS_BUTTON_TYPE.Button"
        :tabindex="-1"
        prefix-icon="minus"
        aria-label="Decrease value"
        :disabled="!props.controls.canDecrement"
        @click="emit('step', -1)"
      />
    </span>
    <span
      :class="[DS_NUMBER_FIELD_CLASSES.ControlButton, DS_NUMBER_FIELD_CLASSES.Increment]"
      data-cy="ds-number-field__increment"
    >
      <DSButton
        :variant="DS_BUTTON_VARIANT.Ghost"
        :size="DS_SIZE.Small"
        :type="DS_BUTTON_TYPE.Button"
        :tabindex="-1"
        prefix-icon="plus"
        aria-label="Increase value"
        :disabled="!props.controls.canIncrement"
        @click="emit('step', 1)"
      />
    </span>
  </div>
</template>

<script setup lang="ts">
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import { DS_BUTTON_TYPE, DS_BUTTON_VARIANT } from "@/src/design_system/button_and_controls/button/types/props";
import { DS_NUMBER_FIELD_CLASSES } from "@/src/design_system/form_elements/number_field/constants/classes";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

const props = defineProps<{
  controls: {
    canIncrement: boolean;
    canDecrement: boolean;
  };
}>();

const emit = defineEmits<{
  (e: "step", direction: 1 | -1): void;
}>();
</script>
